import { ProtocolContentData } from "../../protocol";
export var ManualPositioningMethod;
(function (ManualPositioningMethod) {
    ManualPositioningMethod["Visual"] = "Visual";
    ManualPositioningMethod["Radar"] = "Radar";
})(ManualPositioningMethod || (ManualPositioningMethod = {}));
export var SteeringMode;
(function (SteeringMode) {
    SteeringMode["Manual"] = "Manual";
    SteeringMode["Auto"] = "Auto";
    SteeringMode["TrackPilot"] = "Track-Pilot";
})(SteeringMode || (SteeringMode = {}));
export var ChartType;
(function (ChartType) {
    ChartType["Ecdis"] = "ECDIS";
    ChartType["PaperChart"] = "paper chart";
})(ChartType || (ChartType = {}));
export class SeaChart {
    chartType;
    chartId;
}
export default class NavigationManualInputData extends ProtocolContentData {
    manualPositioningObject;
    manualPositioningMethod;
    manualPositioningBearing;
    manualPositioningRange;
    chartCourse;
    newOrderedCourse;
    steeringMode;
    waterDensity;
    waterDepth;
    seaCharts;
    correctionLeeway;
    correctionCurrent;
    constructor(manualPositioningObject, manualPositioningMethod, manualPositioningBearing, manualPositioningRange, chartCourse, newOrderedCourse, steeringMode, waterDensity, waterDepth, seaCharts, correctionLeeway, correctionCurrent) {
        super();
        this.manualPositioningObject = manualPositioningObject;
        this.manualPositioningMethod = manualPositioningMethod;
        this.manualPositioningBearing = manualPositioningBearing;
        this.manualPositioningRange = manualPositioningRange;
        this.chartCourse = chartCourse;
        this.newOrderedCourse = newOrderedCourse;
        this.steeringMode = steeringMode;
        this.waterDensity = waterDensity;
        this.waterDepth = waterDepth;
        this.seaCharts = seaCharts;
        this.correctionLeeway = correctionLeeway;
        this.correctionCurrent = correctionCurrent;
    }
}
//# sourceMappingURL=NavigationManualInputData.js.map